import React, { Component } from "react";
import { Link } from "react-router-dom";
import { fetchCompany } from "../actions/index";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as Constants from '../constants';

class AppHeader extends Component {

  constructor(props) {
    super(props);
    const pathArray = window.location.hash.split('/');
    this.state = {
      featureFlags: {},
      pathArray: pathArray
    };
  }

  componentDidMount() {
    this.props.fetchCompany().then(response => {
      let featureFlags = response.payload.data.data.feature_flags;
      this.setState({ featureFlags: featureFlags });
      localStorage.setItem('featureFlags', JSON.stringify(featureFlags));
    });
  }


  adminLinks() {
    if (localStorage.getItem('showAdminLinks') == 'true') {
      return (
        <div className="admin_links">
          <Link
            to={`/admin/companies?${Constants.DEFAULT_PAGINATION}`}
            className="navbar-brand"
          >
            {" "}
            Companies{" "}
          </Link>
          <Link
            to={`/admin/email_addresses?${Constants.DEFAULT_PAGINATION}`}
            className="navbar-brand"
          >
            {" "}
            Addresses{" "}
          </Link>
          <Link
            to={`/admin/sent_emails?${Constants.DEFAULT_PAGINATION}`}
            className="navbar-brand"
          >
            {" "}
            Emails{" "}
          </Link>
          <Link
            to={`/admin/email_broadcasts?${Constants.DEFAULT_PAGINATION}`}
            className="navbar-brand"
          >
            {" "}
            EBlasts{" "}
          </Link>
          <Link
            to={`/admin/starter_campaigns?${Constants.DEFAULT_PAGINATION}`}
            className="navbar-brand"
          >
            {" "}
            Starter Workflows{" "}
          </Link>
          <Link
            to={`/admin/leads?${Constants.DEFAULT_PAGINATION}`}
            className="navbar-brand"
          >
            {" "}
            Leads{" "}
          </Link>
        </div>
      );
    }
  }

  render() {
    if (this.props.company == undefined) {
      return <div/>
    } else {
      if ( this.state.pathArray[2] == "terms" || this.state.pathArray[2]  == "status" ) {
        if (localStorage.getItem('showAdminLinks') == 'true') {
          return (
            <div id="header" className="navbar navbar-default">
              <div className="container-fluid">
                <div className="navbar-header" />
                <div className="fr">{this.adminLinks()}</div>
              </div>
            </div>
          );
        } else {
          return null;
        }
      }
      return (
        <div id="header" className="navbar navbar-default">
          <div className="container-fluid">
            {!this.state.featureFlags.sextant_sidenav && (
              <div className="navbar-header">
                <a
                  href="https://leads.realgeeks.com/leads"
                  target="_blank"
                  rel="noreferrer"
                  className="navbar-brand"
                >
                  {" "}
                  &#60; Back to CRM{" "}
                </a>
                <Link
                  to={`/campaigns?${Constants.DEFAULT_PAGINATION}`}
                  className="navbar-brand"
                >
                  {" "}
                  Workflows{" "}
                </Link>
                <Link
                  to={`/geek_ai?${Constants.DEFAULT_PAGINATION}`}
                  className={`navbar-brand ${
                    this.state.featureFlags['geek_ai'] ? "show" : "hide"
                  }`}
                >
                  {" "}
                  Geek AI{" "}
                </Link>
                <Link
                  to={`/templates?${Constants.DEFAULT_PAGINATION}`}
                  className="navbar-brand"
                >
                  {" "}
                  Emails{" "}
                </Link>
                <Link
                  to={`/sms_templates?${Constants.DEFAULT_PAGINATION}`}
                  className="navbar-brand"
                >
                  {" "}
                  SMS{" "}
                </Link>
                <Link
                  to={`/rvm_templates?${Constants.DEFAULT_PAGINATION}`}
                  className={`navbar-brand ${
                    Constants.BETA_SITE_UUIDS.includes(localStorage.getItem('lastSiteUUID')) ? "show" : "hide"
                  }`}
                >
                  {" "}
                  Voicemails{" "}
                </Link>
                <Link
                  to={`/video_templates?${Constants.DEFAULT_PAGINATION}`}
                  className="navbar-brand"
                >
                  {" "}
                  Videos{" "}
                </Link>
                <Link
                  to={`/eblasts?${Constants.DEFAULT_PAGINATION}`}
                  className="navbar-brand"
                >
                  {" "}
                  eBlasts{" "}
                </Link>
                <Link
                  to={`/reactive_responses?${Constants.DEFAULT_PAGINATION}`}
                  className="navbar-brand"
                >
                  {" "}
                  Reactive Responses{" "}
                </Link>
                <Link
                  to={`/starter_campaigns?${Constants.DEFAULT_PAGINATION}`}
                  className="navbar-brand"
                >
                  {" "}
                  Library{" "}
                </Link>
              </div>

            )}
            <div className="fr">
              {this.adminLinks()}
              <Link
                to={`/settings`}
                className="navbar-brand"
              >
                {" "}
                Office Hours{" "}
              </Link>
              <Link to={`/help`} className="navbar-brand">
                {" "}
                Help{" "}
              </Link>
              <Link
                to={`/terms`}
                className="navbar-brand"
              >
                {" "}
                Terms of Service{" "}
              </Link>
            </div>
          </div>
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return { company: state.company.company };
}

export default connect(
  mapStateToProps,
  { fetchCompany }
)(AppHeader);
